import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48,
    width: 28
}

function CrossIcon(props) {
    return (
        <SvgIcon keepPathColor {...props}>
            <g>
                <path
                    d={`M38.1,15.5L15.5,38.1c-0.8,0.8-2,0.8-2.8,0l-2.8-2.8c-0.8-0.8-0.8-2,0-2.8L32.5,9.9c0.8-0.8,
                         2-0.8,2.8,0l2.8,2.8 C38.9,13.5,38.9,14.7,38.1,15.5z`}
                />
                <path
                    d={`M32.5,38.1L9.9,15.5c-0.8-0.8-0.8-2,0-2.8l2.8-2.8c0.8-0.8,2-0.8,2.8,0l22.6,22.6c0.8,0.8,
                         0.8,2,0,2.8l-2.8,2.8 C34.5,38.9,33.3,38.9,32.5,38.1z`}
                />
            </g>
        </SvgIcon>
    )
}

CrossIcon.defaultProps = defaultProps

export { CrossIcon }
